/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Add 'js' class on HTML tag
        $('html').addClass('js');

        // Add element so we can change its layout in CSS and have a better way
        // to trigger narrow resolution (or any other where there's no other way)
        $('body').append('<div id="responsiveResTrig"></div>');
        $('body').append('<div id="responsiveResTrigIE"></div>');

        // Fires Fancybox
        UTIL.fire('common', '_fancybox');

        // Fires Fancybox iframe support
        UTIL.fire('common', '_fancyboxMedia');

        // Mobile nav menu
        UTIL.fire('common', 'setNavMenus');

        // Add responsive version class on body
        UTIL.fire('common', 'setResponsiveClasses');
        UTIL.fire('common', 'registerWindowOnResize', {sController:'common', sFunction:'setResponsiveClasses'});

        // Check if IE 10-11 and add class on body
        UTIL.fire('common', 'setBrowserClasses');

        // Collapsible elements
        UTIL.fire('common', 'collapse');

        // File inputs - use js version (replace the default input by something else)
        UTIL.fire('common', 'switchFileInputs');

        // Turn tabs into a dropdown if there is not enough space
        UTIL.fire('common', 'changeTabsToDrop');
        UTIL.fire('common', 'registerWindowOnResize', {sController:'common', sFunction:'changeTabsToDrop', sParam:{sAction:'resize'}});

        // Setup breadcrumbs and add ellipses element
        UTIL.fire('common', 'setBreadcrumbs');

        // Change breadcrumbs layout if there is not enough space
        UTIL.fire('common', 'reduceBreadcrumbs');
        UTIL.fire('common', 'registerWindowOnResize', {sController:'common', sFunction:'reduceBreadcrumbs'});

        // Turn content into a slider on mobile
        UTIL.fire('common', 'contentSlider');
        UTIL.fire('common', 'registerWindowOnResize', {sController:'common', sFunction:'contentSlider'});

        // Collapsed text
        UTIL.fire('common', 'readMore');

        // Add class on fields' parent when they already have content in them
        UTIL.fire('common', 'inputContent');

        // Add focus to input when add-on is clicked, and do some more magic :)
        UTIL.fire('common', 'inputFocus');

        // Call BootStrap datepicker
        UTIL.fire('common', 'datepicker');

        // Call BootStrap timepicker
        UTIL.fire('common', 'timepicker');

        // Format phone number input fields
        UTIL.fire('common', 'phoneFormat');

        // Header - mobile buttons
        UTIL.fire('common', 'headerMobile');

        // Sidebar empty form (hide form wrapper and remove gap before next element)
        UTIL.fire('common', 'sidebarEmptyForm');

        // FPO slider
        UTIL.fire('common', 'featProductsSlider');

        // Sidebar related product slider
        UTIL.fire('common', 'sidebarRelatedSlider');

        // Featured content slider
        UTIL.fire('common', 'sectionFeatSlider');

        // MatchHeight functions
        UTIL.fire('common', '_matchHeight');

        // ContactForm7 DomEvents
        UTIL.fire('common', '_cf7_events');

        // Create footer map for multiple locations (maps.js)
        UTIL.fire('common', '_mapMultiple');

        // Redirect to a new URL when a custom dropdown link value changes
        UTIL.fire('common', 'customFacetWPLinks');

        UTIL.fire('common', 'formsPopup');

        // Open a popup after few seconds
        UTIL.fire('common', 'automaticPopup');

      },

      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        // Trigger mobile chat window
        UTIL.fire('common', 'triggerChat');

        // Trigger mobile SMS window
        // UTIL.fire('common', 'triggerSMS');

        // Add class on fields' parent when they already have content in them
        UTIL.fire('common', 'inputContent');
      },

      // Redirect to a new URL when a custom dropdown link value changes
      customFacetWPLinks: function(){
        var jqSelect = $('[data-type="custom-dropdown-links"]:first');

        jqSelect.each(function(){
          $(this).on('change', function(){
            if( $(this).val() !== '' ) {
              window.location.href = $(this).val();
            }
          });
        });

        delete jqSelect;
      },

      _mapMultiple: function() {
        // Create footer map for multiple locations (maps.js)
        if($('footer #multiple-map').length){
          mapMultiple();
        }
      },

      registerWindowOnResize: function(oParams) {
        $(window).bind('resize', function () {
          waitForFinalEvent(function(){
            UTIL.fire(oParams.sController, oParams.sFunction, oParams.sParam);
          }, iWindowResizeTimeout, oParams.sController + "." + oParams.sFunction);
        });
      },

      registerWindowOnScroll: function(oParams) {
        $(window).bind('scroll', function () {
          waitForFinalEvent(function(){
            UTIL.fire(oParams.sController, oParams.sFunction);
          }, iWindowResizeTimeout, oParams.sController + "." + oParams.sFunction);
        });
      },

      _fancybox: function() {
        if($('.fancybox').length){
          var closeBtnLabel = "Close";

          if($('.lang-fr')){
            closeBtnLabel = "Fermer";
          }

          $('.fancybox:not([href="#form-hidden-product"]):not([href="#hidden-form-calculator"])').fancybox({
            maxWidth: 800,
            padding: 0,
            tpl: {
              closeBtn: '<a title="'+closeBtnLabel+'" class="fancybox-item fancybox-close" href="javascript:;"></a>',
            },
            afterShow: function(){
              $(this.skin).find('.form-group').each(function(){
                UTIL.fire('common', 'inputContent', $(this));
              });
            }
          });

          $('.fancybox[href="#form-hidden-product"]').fancybox({
            wrapCSS: 'fancy-ecom-product',
            maxWidth: 850,
            padding: 0,
            tpl: {
              closeBtn: '<a title="'+closeBtnLabel+'" class="fancybox-item fancybox-close" href="javascript:;"></a>',
            }
          });
        }
      },
      _fancyboxMedia: function() {
        if($('.fancybox-media').length){
          var closeBtnLabel = "Close";
          
          if($('.lang-fr')){
            closeBtnLabel = "Fermer";
          }

          $('.fancybox-media').fancybox({
            padding: 0,
            width: 640,
            height: 360,
            autoDimensions: false,
            type: 'iframe',
            tpl: {
              closeBtn: '<a title="'+closeBtnLabel+'" class="fancybox-item fancybox-close" href="javascript:;"></a>',
            }
          });
        }
      },
      collapse: function() {
        $('.collapse-btn').on('click', function(e) {
          e.preventDefault();
          var $this = $(this);
          var $collapse = $this.closest('.collapse-group').find('.collapse');
          $collapse.collapse('toggle');
        });
      },
      setResponsiveClasses: function(){
        // Add or remove classes on window resize
        var availableSizes = ['mobile','tablet','narrow','wide','extrawide'];
        var API = $("#mobilenavMain").data( "mmenu" );

        keepSelectedSizeOnly = function(size){
          for (a = 0; a < availableSizes.length; ++a) {
            if (availableSizes[a] != size){ $('body').removeClass(availableSizes[a]);}
          }
          $('body').addClass(size);
        };

        setSize = function(size){
          // If the site doesn't already have the correct class
          if((!$('body.'+size).length)){

            if(size == 'mobile'){
              keepSelectedSizeOnly('mobile');
            }else{
              // Close the mobile nav
              API.close();

              keepSelectedSizeOnly(size);
            }

            // Header - mobile buttons
            UTIL.fire('common', 'headerMobile');
          }
        };

        // is mobile
        if($('#responsiveResTrig').css('width') == '50px') {
          setSize('mobile');
        }
        // is tablet resolution
        else if($('#responsiveResTrig').css('width') == '75px') {
          setSize('tablet');
        }
        // is wide resolution
        else if($('#responsiveResTrig').css('width') == '200px') {
          setSize('wide');
        }
        // is extra-wide resolution
        else if($('#responsiveResTrig').css('width') == '300px') {
          setSize('extrawide');
        }
        // is narrow resolution
        else {
          setSize('narrow');
        }
      },
      setBrowserClasses: function() {
        // is IE 10-11
        if($('#responsiveResTrigIE').css('width') == '50px') {
          $('body').addClass('is-ie');
        }
      },
      setNavMenus: function(){
        var termHome = (lang == 'fr') ? "Accueil" : "Home";

        // Mobile nav menu
        $('#siteHeader').append('<div id="mobilenavMain" class="mobilenav"></div>');
        $('#mainnav ul').clone().appendTo($("#mobilenavMain"));

        $('.mobilenav').mmenu({
          // configuration
          classNames: {
            list: "menu"
          },
          offCanvas: {
            pageSelector: "#page",
            position: "bottom",
            zposition: "front"
          },
          extensions: [
            "theme-dark",
            "positioning",
            "pagedim-black"
          ]
        });

        var API = $("#mobilenavMain").data( "mmenu" );

        $('#mobilebtns').appendTo('body');

        // If using the single CTA version
        if ($('#mobilebtns .singleCTA').length) {
          // Change mobilebtns CTA text and link if sidebar form present on page
          if ($('#sidebar form.feat .fieldsets > header > h2').length) {
            $('#mobilebtns .cta a').attr('href', '#sidebar');
            $('#mobilebtns .cta a > span').html($('#sidebar form.feat .fieldsets > header > h2').html().replace(/<br\s*\/?>/gi,' ')); //remove <br> tags
          }
        }

        $(window).scroll(function(){
          if ($('#siteHeader').visible()) {
            $('#mobilebtns').removeClass('visible');
            $('body').removeClass('mobilebtns-visible');
          }
          else {
            $('#mobilebtns').addClass('visible');
            $('body').addClass('mobilebtns-visible');
          }
        }).scroll();


        // ---- HOME LINK ----
        // Add a "Home" link if it's not already in the main nav
        if(!$('#mainnav ul .home').length) {
          $('#mobilenavMain .mm-panels > .mm-panel:first-child > ul').prepend('<li><a href="/' + lang + '/">' + termHome + '</a></li>');
        }

        // ---- QUICK LINKS ----
        // Do not copy the Contact Us link if it is also present in the main nav
        if($('#mainnav ul .contact').length) {
          $('#siteHeader .quicklinks li:not(.contact)').clone().appendTo('#mobilenavMain .mm-panels > .mm-panel:first-child > ul');
        }
        else {
          $('#siteHeader .quicklinks li').clone().appendTo('#mobilenavMain .mm-panels > .mm-panel:first-child > ul');
        }

        // ---- HEADER CUSTOM LINKS ----
        $('#siteHeader .customlinks > ul > li').clone().appendTo('#mobilenavMain .mm-panels > .mm-panel:first-child > ul');
        $("#mobilenavMain .mm-panels > .mm-panel:first-child > ul .img a").each(function(){
          $(this).html($(this).find('img').attr('alt'));
        });
        

        // ---- FOOTER LINKS (Boutique pages) ----
        $('#siteFooter .navigation .col.shopping > ul > li').clone().appendTo('#mobilenavMain .mm-panels > .mm-panel:first-child > ul');

        if($('body.is-boutique-page').length) {
          // Do not copy the Contact Us link if it is also present in the main nav
          if($('#mainnav ul .contact').length) {
            $('#siteFooter .navigation .col.about > ul > li:not(.contact)').clone().appendTo('#mobilenavMain .mm-panels > .mm-panel:first-child > ul');
          }
          else {
            $('#siteFooter .navigation .col.about > ul > li').clone().appendTo('#mobilenavMain .mm-panels > .mm-panel:first-child > ul');
          }
        }

        // ---- LANGUAGE ----
        if( $('#siteHeader .lng').length ) {
          // Add divider before language links
          $("#mobilenavMain .mm-panels > .mm-panel:first-child > ul").append('<li class="Divider"></li>');

          // Add wrapper for links
          $("#mobilenavMain .mm-panels > .mm-panel:first-child > ul").append('<li class="lngSwitcher"><ul></ul></li>');

          // Insert language links in mobile menu
          $("#mobilenavMain .mm-panels > .mm-panel:first-child > ul > li.lngSwitcher > ul").html($('#siteHeader .lng li:not(.current)').clone());
        }

        // ---- SOCIAL MEDIA ----
        if( $('#siteHeader .infos .social').length ) {
          // Add divider before group social media links
          $("#mobilenavMain .mm-panels > .mm-panel:first-child > ul").append('<li class="Divider"><span>' + $('#siteHeader .infos .social h3').text() + '</span></li>');

          // Add wrapper for links
          $("#mobilenavMain .mm-panels > .mm-panel:first-child > ul").append('<li class="social"><ul></ul></li>');

          // Insert social media links in mobile menu
          $("#mobilenavMain .mm-panels > .mm-panel:first-child > ul > li.social > ul").html($('#siteHeader .infos .social li').clone());
        }


        // ---- OPEN/CLOSE MMENU ----
        API.bind('closing', function () {
          $('#mainnav nav button, #mobilebtns .nav button').removeClass('is-active');
          $('#mobilebtns').removeClass('menu-opened');
        });

        API.bind('opening', function () {
          $('#mainnav nav button, #mobilebtns .nav button').addClass('is-active');
          $('#mobilebtns').addClass('menu-opened');
        });

        $('#mainnav nav button, #mobilebtns .nav button').click(function() {
          // If menu is already opened, we need to close it
          if($("#mobilenavMain").hasClass('mm-opened')) {
            API.close();
          }
          else {
            // Close potential dropdowns in mobile btns
            $('#siteHeader .mobilebtns, #mobilebtns').find('> ul > li > a').siblings('.content').hide();
            $('#siteHeader .mobilebtns, #mobilebtns').find('> ul > li').parent().removeClass('on');

            API.open();
          }

          $(this).blur();
        });


        // ---- OPEN MOBILEBTNS DROPDOWNS ----
        $('#siteHeader .mobilebtns, #mobilebtns').find('> ul > li').has('> .content').find('> a').click(function() {
          var $clickedLink = $(this);
          var $otherItems = $('#siteHeader .mobilebtns, #mobilebtns').find('> ul > li > a').not($clickedLink).parent();

          $otherItems.find('> .content').hide();
          $otherItems.removeClass('on');

          // If menu is opened, we need to close it
          if($("#mobilenavMain").hasClass('mm-opened')) {
            API.close();
          }

          if($clickedLink.siblings('.content')) {
            $clickedLink.siblings('.content').toggle();
            $clickedLink.parent().toggleClass('on');

            $clickedLink.blur();

            return false;
          }
        });

        // Main nav drop downs
        UTIL.fire('common', 'mainnavDropdowns');
      },
      mainnavDropdowns: function(){
        // Main nav drop downs
        mainnavPositionDropdown = function($thisItem, $dropdown){
          var $mainwrap       = $('#siteHeader');       // full width of the menu's wrapper
          var wrapperWidth    = $mainwrap.width() - 20; // we should keep 10px between a dropdown and the edge of the wrapper
          var $parentItem     = $thisItem;              // selected menu
          var parentWidth     = $parentItem.width();    // selected menu width

          $dropdown.removeClass('dropShort');

          var dropdownWidth   = $dropdown.outerWidth();      // sub menu width of the selected menu

          // check available space
          if(($parentItem.offset().left + dropdownWidth) <= ($mainwrap.offset().left + wrapperWidth)){
            $dropdown.addClass('dropLeft');
          }
          else {
            // if the trigger item starts past the wrapper's halfway point, the dropdown needs to be position from the right side
            if($parentItem.offset().left > ($mainwrap.offset().left + (wrapperWidth / 2))){
              $dropdown.addClass('dropRight');
            }
            // if not, we position it from the left
            else{
              $dropdown.addClass('dropLeft');
            }
          }

          // set dropdown width so it's at least as wide as the corresponding menu item label's bg
          if(dropdownWidth < parentWidth) {
            $dropdown.addClass('dropShort');
          }
        };

        // to remove an element from the subnav timer array
        removeArrayElem = function($elem, array){
          clearIndex = array.indexOf($elem);
          if(clearIndex > -1){
            array.splice(clearIndex, 1);
          }
        };

        // all sub menus
        var $mainnavItemWDrop = $('#mainnav nav > ul > li.menu-item-has-children');

        // // add a span around all 1st level links
        // $('#mainnav nav > ul > li > a').wrapInner('<span></span>');

        // add a span around the text links for all 1st level links
        $('#mainnav nav > ul > li > a > span').wrapInner('<span class="label"></span>');

        // add the arrow on the links
        $mainnavItemWDrop.find('> a > span').append('<span class="arrow"></span>');

        // add a class on the sub menu
        $mainnavItemWDrop.find('> ul').wrap('<div class="drop"></div>');

        // add a class on menu to show that there are sub menus
        if($mainnavItemWDrop.length){
          $mainnavItemWDrop.parents('#mainnav nav > ul').addClass('has-drops');
        }


        // -------------- 3rd level of menus --------------
        // all sub menus
        var $mainnavSubItemWDrop = $('#mainnav nav > ul > li.menu-item-has-children .drop > ul > li.menu-item-has-children');

        // Does the second-level hyperlinks contains a div.main tag? If not, wrap the hyperlink with it
        if( $mainnavSubItemWDrop.length && ! $mainnavSubItemWDrop.find('> .main').length ) {
          $mainnavSubItemWDrop.find('> a').wrap('<div class="main"></div>');
        }

        // add a trigger on all items that have children
        $mainnavSubItemWDrop.find('.main > a').after('<button class="trig" title="' + termOpenClose + '"><span>' + termOpenClose + '</span></button>');


        if(!$('body.mobile').length){
          $mainnavItemWDrop.hoverIntent(function(){
            var $thisItem = $(this);
            mainnavPositionDropdown($thisItem, $thisItem.find('.drop > ul'));
            $thisItem.addClass('on');
            $thisItem.find('.drop > ul').slideDown(250);
          }, function(){
            var $thisItem = $(this);
            var $thisItemNav = $thisItem.find('.drop');

            if($thisItemNav.is(':visible')){
              $thisItemNav.find('> ul').slideUp(100, function(){
                $thisItem.removeClass('on');

                // Close all 3rd level items
                $mainnavSubItemWDrop.removeClass('on').find('> ul').slideUp(0);
              });
            }
          });


          // 3rd level of menu
          $mainnavSubItemWDrop.find('.main > .trig').click(function(){
            var $thisSubItem = $(this).parents('#mainnav nav > ul > li.menu-item-has-children .drop > ul > li');

            if($thisSubItem.hasClass('on')) {
              $thisSubItem.find('> ul').stop().slideUp(100, function(){
                $thisSubItem.removeClass('on');
              });
            }
            else {
              $thisSubItem.addClass('on');
              $thisSubItem.find('> ul').stop().slideDown(250);
            }

            $(this).blur();
          });
        }
      },
      headerMobile: function(){
        // Header - mobile buttons

        var $headerLogo = $('#siteHeader .logo');
        var headerBtnsCount = $('#siteHeader .mobilebtns > ul > li').length;
        var headerBtnsWidth = $('#siteHeader .mobilebtns > ul > li:first-child').width();
        var headerBtnsTotalWidth = (headerBtnsCount * headerBtnsWidth) + (headerBtnsCount - 1); //(nb of items * item width) + spacing

        if($('body.mobile, body.tablet, body.narrow').length) {
          if(headerBtnsCount > 0) {
            $headerLogo.css({
              right: headerBtnsTotalWidth + $('#mainnav').width()
            });
          }
        }
        else {
          $headerLogo.removeAttr('style');
        }
      },
      switchSubmitBtns: function(){
        // Submit btns - use js version (replace the default input by something else)
        if($('form').length){
          $('form').each(function(){
            var $form = $(this);
            var $btnWrap = $form.find('.form-action');
            var $input = $btnWrap.find('input[type="submit"]');

            if($input.length) {
              var btnText = $input.val();

              $btnWrap.append('<div class="btn"><a href="#" class="form-submit wpcf7-submit"><span>' + btnText + '</span></a></div>');

              var $btn = $btnWrap.find('.btn');

              $input.remove();

              $btn.find('a').click(function(){
                $(this).blur();

                $form.submit();

                return false;
              });
            }
          });
        }
      },
      switchFileInputs: function(){
        // File inputs - use js version (replace the default input by something else)
        if($('form').length){
          if(!$('body.is-ie').length) {
            $('form').each(function(){
              var btnText = "Choose <span>File</span>";

              var $form = $(this);
              var $formGroup = $form.find('.form-group.file');
              var $inputWrap = $formGroup.find('.wpcf7-form-control-wrap');
              var $input = $inputWrap.find('input[type="file"]');

              if(lang == 'fr') {
                btnText = "Choisir <span>fichier</span>";
              }
              else if(lang == 'es') {
                btnText = "Elegir <span>archivo</span>";
              }

              if($input.length) {
                var inputText = $input.val();

                $inputWrap.append('<div class="file-input"><input type="text" name="file-input" disabled value="' + inputText + '" class="wpcf7-form-control wpcf7-text form-control"><button type="button"><span>' + btnText + '</span></button></div>');

                $input.appendTo($inputWrap.find('button'));

                var $textInput = $inputWrap.find('.file-input input[type="text"]');

                $formGroup.addClass('input-switched');

                $input.change(function() {
                  $textInput.val(this.files[0].name);
                });

                $textInput.click(function() {
                  $input.click();
                });
              }
            });
          }
        }
      },
      changeTabsToDrop: function(oParams) {
        // Turn tabs into a dropdown if there is not enough space

        var sAction = (oParams && oParams.sAction) ? oParams.sAction : '';
        var oElement = (oParams && oParams.oElement) ? oParams.oElement : '';

        if($('.tabs-group').length) {
          var $tabGroups = oElement ? oElement : $('.tabs-group');

          // If calling this when the window is resized, we need to put back as horizontal list before we calculate anything
          if(sAction && sAction == 'resize') {
            $tabGroups.removeClass('btn-group');
            $tabGroups.find('.dropdown-menu').removeClass('dropdown-menu');
          }

          $tabGroups.each(function(){
            var $group = $(this);
            var $tabs = $group.find('> .tabs');
            var $tabItems = $tabs.find('> li');
            var tabsWidth = 0;
            var $btn = $group.find('> button');

            // Don't do this for vertical tabs or other ones that we need more control over
            if(!$group.hasClass('noAutoSwitch')) {
              // Normal tabs
              if(!$group.hasClass('customSwitch')) {
                var availableWidth = $group.width();
              }
              // Tabs using a different width calculation
              else {
                var availableWidth = $group.parents('.customSwitchWrap').width() - $group.siblings().width();
              }

              // Calculate tabs width
              $tabItems.each(function(){
                tabsWidth += $(this).outerWidth(true);
              });

              // If there is not enough space for the UL to be displayed on 1 line, show the dropdown instead
              if(tabsWidth > availableWidth) {
                $group.addClass('btn-group');
                $tabs.addClass('dropdown-menu');

                if(!$group.hasClass('noBtnLabelSwitch')) {
                  // Change button label text to current active tab
                  $btn.find('.label').html($group.find('.active a').html());
                }
              }
              else {
                $group.removeClass('btn-group');
                $tabs.removeClass('dropdown-menu');
              }
            }

            // We need to call some Bootstrap JS so the tab switching still works
            $tabItems.find('a').click(function(e){
              $trigger = $(this);
              $tabContent = $trigger.parents('.tabs-group').siblings('.tab-content');

              // Check if they're real tabs:
              // If .tab-content exists
              if($tabContent.length) {
                // If the "tab" doesn't have a "link" class
                if(!$trigger.parent().hasClass('link')) {
                  $tabItems.not($trigger.parent()).removeClass('active');

                  e.preventDefault();

                  $trigger.tab('show');

                  if(!$group.hasClass('noBtnLabelSwitch')) {
                    // Change button label text to clicked tab
                    $btn.find('.label').html($trigger.html());
                  }

                  $trigger.on('shown.bs.tab', function(e) {
                    // If there are visible sub tabs, calculate the space available again
                    if($tabContent.find('.tab-pane.active .tabs-group').length) {
                      UTIL.fire('common', 'changeTabsToDrop', {sAction:'resize', oElement:$tabContent.find('.tab-pane.active .tabs-group')});
                    }
                  });
                }
              }

              $trigger.blur();
            });
          });
        }

        // Make sure the dropdown menu also works
        $('.dropdown-toggle').dropdown();

      },
      setBreadcrumbs: function() {
        // Add ellipses in breadcrumbs

        if($('#featBreadcrumbs').length) {
          var $oBreadcrumbs = $('#featBreadcrumbs');

          // Add ellipses
          $oBreadcrumbs.find('li:first-child').after('<li class="ellipses"><a href="#"><span>...</span></a></li>');


          // Change ellipses link to the one on the next element
          var $oEllipses = $oBreadcrumbs.find('.ellipses');

          $oEllipses.find('a').attr('href', $oEllipses.next().find('a').attr('href'));
        }
      },
      reduceBreadcrumbs: function() {
        // Display ellipses within breadcrumbs when not enough space
        // Adapted from https://bootsnipp.com/snippets/featured/responsive-breadcrumbs

        if($('#featBreadcrumbs').length) {
          var $oBreadcrumbs = $('#featBreadcrumbs');
          var $oEllipses = $oBreadcrumbs.find('.ellipses');

          if($oBreadcrumbs.find('li:not(.ellipses):hidden').length > 0) {
            $oEllipses.css({
              'display': 'flex'
            });
          }
          else {
            $oEllipses.hide();
          }
        }
      },
      contentSlider: function() {
        // Turn content into a slider on mobile

        var $elem = $('.contentSlider');

        if($elem.length) {
          // Make sure there's more than one item, otherwise there's no point to a slider
          if($elem.find('.item').length > 1) {
            $elem.each(function(){
              $thisElem = $(this);

              if($('body.mobile').length){
                // If mobile and slider is not already set up, set it up
                if(!$thisElem.hasClass('slick-slider')) {
                  // When slider is initialized
                  $thisElem.on('init', function(event, slick){
                    // Add spans in slider pagination
                    $(this).find('.slick-dots li button').wrapInner('<span />');
                  });

                  $thisElem.slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="' + termPrev + '" role="button" style="display: block;"><span>' + termPrev + '</span></button>',
                    nextArrow: '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="' + termNext + '" role="button" style="display: block;"><span>' + termNext + '</span></button>',
                    dots: true,
                    responsive: [
                      {
                        breakpoint: 768,
                        settings: 'unslick'
                      }
                    ]
                  });
                }
              }
              else {
                // If not mobile but slider is already set up, we need to remove it
                if($thisElem.hasClass('slick-slider')) {
                  $thisElem.slick('unslick');
                }
              }
            });
          }
        }
      },
      readMore: function(){
        // Collapsed text
        toggleText = function(className){
          var termExpand = (lang == 'fr') ? "Lire la suite" : "Read More";
          var termCollapse = (lang == 'fr') ? "Réduire" : "Collapse Text";

          var symbolExpand = '+';
          var symbolCollapse = '-';

          $(className).each(function(){
            // Add Bootstrap class
            $(this).addClass('collapse');

            if(!$(this).find('+ .readmore').length){
              $(this).after('<p class="readmore"><a href="#"><span>' + symbolExpand + ' </span>'+termExpand+'</a></p>');
            }
          });

          $(className +' + .readmore a').click(function(){
            $trig = $(this);
            $textMore = $(this).parent().prev();

            if($textMore.length){
              $textMore.collapse('toggle');

              // Change trigger text when text is expanded
              $textMore.on('shown.bs.collapse', function(){
                $trig.html('<span>' + symbolCollapse + ' </span>' + termCollapse);
              });
              // Change trigger text when text is collapsed
              $textMore.on('hidden.bs.collapse', function(){
                $trig.html('<span>' + symbolExpand + ' </span>' + termExpand);
              });

              $trig.blur();

              return false;
            }
          });
        };

        // Set all read more texts
        toggleText('.textMore:not(.mobile)');

        // Set all read more texts specific to mobile version
        if($('body.mobile').length) {
          toggleText('.textMore.mobile');
        }
      },
      sidebarEmptyForm: function() {
        // Sidebar empty form (hide form wrapper and remove gap before next element)
        if( $('#sidebar form.feat').length && ! $('#sidebar form.feat .fieldsets').length ) {
          $('#sidebar form.feat').parents('.wpcf7').addClass('hidden');
        }
      },
      automaticPopup: function(){
        if ($('#popup').length) {
          var timeout = parseInt($('#popup').attr('data-timeout'));

          if ($('#popup').attr('data-expiry')) {
            var date = new Date();
            var minutes = parseInt($('#popup').attr('data-expiry'));
            date.setTime(date.getTime() + (minutes * 60 * 1000));

            if (!$.cookie('powergo_popup')) {
              oTimerFormOpener = setTimeout(function() {
                $('#popup-trigger').trigger('click');
              }, timeout);

              $.cookie('powergo_popup', '1', { expires: date, path: '/' });
            }
          } else {
            oTimerFormOpener = setTimeout(function() {
              $('#popup-trigger').trigger('click');
            }, timeout);
          }
        }
      },
      featProductsSlider: function() {
        // When slider is initialized

        var sElem = '.featProducts#featUsed .listWImgs';
        var $elem = $(sElem);

        if($elem.length) {
          if($elem.find('.item').length > 1) {
            $elem.on('init', function(event, slick){
              // Add spans in slider pagination
              $(this).find('.slick-dots li button').wrapInner('<span />');
            });

            oPgsSliders.createNewSlick('feat_products', sElem);
          }
        }

      },
      sidebarRelatedSlider: function() {
        // When slider is initialized

        var sElem = '#sidebar .related-products .listWImgs';
        var $elem = $(sElem);

        if($elem.length) {
          if($elem.find('.item').length > 1) {
            $elem.on('init', function(event, slick){
              // Add spans in slider pagination
              $(this).find('.slick-dots li button').wrapInner('<span />');
              $(this).parents('#slider').addClass('is-initialized');

              // Add 'hover' class when hovering the slider
              $(this).hover(function(){
                $(this).parents('#slider').addClass('hover');
              }, function(){
                $(this).parents('#slider').removeClass('hover');
              });
            });

            oPgsSliders.createNewSlick('sidebar_related_products', sElem);
          }
        }
      },
      inputContent: function(oElement) {
        // Add class on fields' parent when they already have content in them

        moveLabel = function(oGroup) {
          if(oGroup.length) {
            var oFormControl = oGroup.find('.form-control');

            // If element is a select or is not empty, and if value isn't the same as the label
            if( oFormControl.val().trim() != '' ) {
              oGroup.addClass('move-label');
            }
            else {
              oGroup.removeClass('move-label');
            }
          }
        };

        if(oElement) {
          moveLabel(oElement);
        }
        else {
          var oForms = $('#sidebar, #mainContent .wpcf7, .fancybox-wrap').find('form');

          // ****** MAKE SURE THE CLASS LIST IS THE SAME AS IN THE SCSS FILE ******
          oForms.find('.form-group:not(.radio):not(.checkbox):not(.file):not(.has-label)').each(function(){
            moveLabel($(this));
          });
        }
      },
      inputFocus: function() {
        var oForms = $('form');

        // Add class on textareas' parent
        oForms.find('textarea').closest('.form-group').addClass('has-textarea');

        // Add focus to input when add-on is clicked
        if (oForms.find('.input-group-addon')) {
          $('.input-group-addon').click(function() {
            $(this).parent().find('input, select, textarea').focus();
          });
        }

        // Add class to field parent on focus
        oForms.find('.form-control').focus(function(){
          $(this).closest('.form-group').addClass('has-focus move-label');
        });

        // Remove class on field parent on blur
        oForms.find('.form-control').blur(function(){
          $(this).closest('.form-group').removeClass('has-focus');

          // Add class on fields' parent when they already have content in them
          UTIL.fire('common', 'inputContent', $(this).closest('.form-group'));
        });
      },
      datepicker: function() {
        // Datepicker
        if ($('form .date').length) {
          $('form .date input').addClass('datepicker');
        }

        if ($('.datepicker').length) {
          $('.datepicker').datepicker({
            dateFormat: 'dd/mm/yy',
            onClose: function(){
              this.focus();
            }
          });
        }
      },
      timepicker: function() {

        if ($('form .time').length) {
          $('form .time input').addClass('timepicker');
        }

        if ($('.timepicker').length) {
          $('.timepicker').timepicker().on('changeTime.timepicker', function(e) {
            UTIL.fire('common', 'inputContent', $(this).closest('.form-group'));
          });
        }
      },
      phoneFormat: function() {
        // Format phone number input fields
        if ($('input[name="phone"]').length) {
          $('input[name="phone"]').mask('(000) 000-0000  ZZZZZZZZZZZZ', {'translation': {
            Z: {pattern: /[A-Za-z0-9 ]/},
            }
          });
        }
      },

      sectionFeatSlider: function() {
        if($('#contentBefore .featSlider .slider').length) {
          oPgsSliders.createNewSlick('section_feat_slider', '#contentBefore .featSlider .slider');
        }
      },

      triggerChat: function() {
        $('#mobilebtns .chat a').on('click', function(e) {
          var sChatService = $(this).attr('data-service');

          e.preventDefault();

          if (sChatService == 'livechatinc') {
            LC_API.open_chat_window();
          }
          else if (sChatService == 'contactatonce') {
            if($('.lp_desktop:first .lp_minimized .lp_maximize').length) {
              $('.lp_desktop:first .lp_minimized .lp_maximize').trigger('click');
            }
            else if($('div[id^="iCoder_"]:first #caoStandardChatArea').length) {
              $('div[id^="iCoder_"]:first #caoStandardChatArea').trigger('click');
            }
            else if($('div[id^="iCoder_"]:first #caoMinChatArea').length) {
              $('div[id^="iCoder_"]:first #caoMinChatArea').trigger('click');
            }
            else if($('div[id^="iCoder_"]:first #caoMobileChatArea').length) {
              $('div[id^="iCoder_"]:first #caoMobileChatArea').trigger('click');
            }
          }
        });
      },

      triggerSMS: function() {
        $('#mobilebtns .sms a').on('click', function(e) {
          var sChatService = $(this).attr('data-service');

          e.preventDefault();

          if (sChatService == 'contactatonce') {
            // if($('.lp_desktop:first .lp_minimized .lp_maximize').length) {
            //   $('.lp_desktop:first .lp_minimized .lp_maximize').trigger('click');
            // }
            if($('div[id^="iCoder_"]:first #caoStandardMtcArea').length) {
              $('div[id^="iCoder_"]:first #caoStandardMtcArea').trigger('click');
            }
            else if($('div[id^="iCoder_"]:first #caoMinMtcArea').length) {
              $('div[id^="iCoder_"]:first #caoMinMtcArea').trigger('click');
            }
            else if($('div[id^="iCoder_"]:first #caoMobileMtcArea').length) {
              $('div[id^="iCoder_"]:first #caoMobileMtcArea').trigger('click');
            }
          }
        });
      },

      _matchHeight: function() {
        // ---- FEAT BTNS ----
        if($('#featBtns').length) {
          $('#featBtns .listWImgs .item .img').matchHeight();
          $('#featBtns .listWImgs .item h3').matchHeight();
        }

        // ---- FEAT PRODUCTS (FPO & ETC) ----
        if($('.featProducts').length) {
          $('.featProducts .listWImgs').imagesLoaded(function() {
            // #featUsed
            $('.featProducts#featUsed .listWImgs .item .img').matchHeight();
            $('.featProducts#featUsed .listWImgs .item h3').matchHeight();
            $('.featProducts#featUsed .listWImgs .item .specs').matchHeight();
            $('.featProducts#featUsed .listWImgs .item .price').matchHeight();
            $('.featProducts#featUsed .listWImgs .item .listWImgsContent').matchHeight();

            // Ecom stuff
            // Can't do it on the image, so doing it on the the other elements would be useless. Sticking with just the wrapper.
            $('.featProducts:not(#featUsed) .listWImgs li.product').matchHeight();
          });

          if($('.featProducts:not(#featUsed)').length) {
            $(document).ajaxSuccess(function() {
              $('.featProducts:not(#featUsed) .products').imagesLoaded( function() {
                $('.featProducts:not(#featUsed) .products').each(function(){
                  $(this).find('li.product').matchHeight();
                });
              });
            });
          }
        }

        // ---- CONTENTAFTER ----
        if($('#contentAfter').length) {
          if($('#contentAfter .related-products').length) {
            $('#contentAfter .related-products .listWImgs').imagesLoaded(function() {
              $('#contentAfter .related-products .listWImgs .item .img').matchHeight();
              $('#contentAfter .related-products .listWImgs .item h3').matchHeight();
              $('#contentAfter .related-products .listWImgs .item > .content').matchHeight();
            });
          }
        }

        // // ---- USED ----
        // if($('body.is-used').length) {
        //   // Listing
        //   if($('body.is-listing').length) {
        //     $(document).on('facetwp-loaded', function() {
        //       if($('#mainContent .product-list').length) {
        //         $('#mainContent .product-list').imagesLoaded(function() {
        //           $('#mainContent .product-list .item .img').matchHeight();
        //           $('#mainContent .product-list .item > .content').matchHeight();
        //         });
        //       }
        //     });
        //   }
        // }

        // // ---- PROMOS ----
        // if($('.is-promos').length) {
        //   // Listing
        //   if($('.is-listing').length) {
        //     if($('#mainContent .promotion-list').length) {
        //       $('#mainContent .promotion-list .item .img').matchHeight();
        //       $('#mainContent .promotion-list .item > .content').matchHeight();
        //     }
        //   }
        // }

        // ---- BLOG ----
        if($('body.is-blog').length) {
          // Listing
          if($('.is-listing').length) {
            $(document).on('facetwp-loaded', function() {
              if($('#mainContent .blog-list').length) {
                $('#mainContent .blog-list .item .img').matchHeight();
                // $('#mainContent .blog-list .item h2').matchHeight();
                $('#mainContent .blog-list .item > .content').matchHeight();
              }
            });
          }
        }

        // ---- TEAM ----
        if($('body.is-team').length) {
          // Listing
          $(document).on('facetwp-loaded', function() {
            if($('#mainContent .team-list').length) {
              $('#mainContent .team-list').imagesLoaded(function() {
                $('#mainContent .team-list .item .img').matchHeight();
                $('#mainContent .team-list .item h3').matchHeight();
                $('#mainContent .team-list .item > .content').matchHeight();
              });
            }
          });
        }

        // ---- NEW ----
        if($('body.is-new').length) {
          // Listing
          UTIL.fire('common', '_matchHeightNewListing');
        }
      },

      _matchHeightNewListing: function(){
        $(document).on('facetwp-loaded', function() {
          if($('#mainContent .product-list').length) {
            $('#mainContent .product-list').imagesLoaded(function() {
              $('#mainContent .product-list .item .img').matchHeight();
              $('#mainContent .product-list .item h4').matchHeight();
              $('#mainContent .product-list .item > .content').matchHeight();
            });
          }
        });
      },

      // ContactForm7 DomEvents
      // Replace deprecated cf7 function on_sent_ok(), on_submit() or other events
      // https://contactform7.com/dom-events/
      _cf7_events: function() {
        // return;
        // wpcf7mailsent: Fires when an Ajax form submission has completed successfully, and mail has been sent.
        document.addEventListener( 'wpcf7mailsent', function( event ) {
          formConfirmation(event.detail.contactFormId);
        }, false );

        // wpcf7submit: Fires when an Ajax form submission has completed successfully, regardless of other incidents.
        document.addEventListener( 'wpcf7submit', function( event ) {
          formScroll(event.detail.contactFormId);
        }, false );

        // wpcf7invalid: Fires when an Ajax form submission has completed successfully, but mail hasn't been sent because
        // there are fields with invalid input.
        document.addEventListener( 'wpcf7invalid', function( event ) {
          formInvalidFields(event.detail.contactFormId);
        }, false );
      },

      formsPopup: function() {
        if( ! $('[data-pgs-form]').length ) {
          return;
        }

        $('[data-pgs-form]').each(function(){

          $(this).bind('click.resetOnClose', function(e){
            // e.preventDefault();

            var jqForm = $($(this).attr('href'));

            if( ! jqForm.length )  {
              return;
            }

            var sType   = $(this).attr('data-pgs-type');
            var sMake   = $(this).attr('data-pgs-make');
            var sModel  = $(this).attr('data-pgs-model');
            var sYear   = $(this).attr('data-pgs-year');
            var sStock  = $(this).attr('data-pgs-stock');
            var sPostId = $(this).attr('data-pgs-postid');

            jqForm.find('[name="hidden-type"]').val(sType);
            jqForm.find('[name="hidden-make"]').val(sMake);
            jqForm.find('[name="hidden-year"]').val(sYear);
            jqForm.find('[name="hidden-model"]').val(sModel);
            jqForm.find('[name="hidden-stock"]').val(sStock);

            var jqAdfLead = jqForm.find('[name="iAdfLead"]');
            if( ! jqAdfLead.length || parseInt(jqAdfLead.val()) !== 1 ) {
              return;
            }

            var sAdfModel = sModel;
            if( sType === 'used' ) {
              sAdfModel = sStock + ' - ' + sModel;
            }
            jqForm.find('[name="sAdfVehicleYear"]').val(sYear);
            jqForm.find('[name="sAdfVehicleModel"]').val(sAdfModel);
            jqForm.find('[name="sAdfVehicleMake"]').val(sMake);
            jqForm.find('[name="sAdfVehicleStatus"]').val(sType);
            jqForm.find('[name="sAdfPostId"]').val(sPostId);

          });
        });
      },
    },

    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        // Home video
        UTIL.fire('home', 'showVideo');

        // Fire home slider
        UTIL.fire('home', 'homeSlider');
      },

      showVideo: function() {
        // Home video
        if($('body.mobile, body.tablet').length) {
          // Hide video bg
          $('#hero .img video').hide();
        }
        else {
          // If video element already exists, just show it
          if($('#hero .img video').length) {
            $('#hero .img video').show();
          }
          // If not, create it
          else {
            $('<video autoplay loop muted><source src="/wp-content/themes/site/assets/videos/home.mp4" type="video/mp4"></video>').prependTo($('#hero .img'));
          }

          // Add overlay
          $('#hero').addClass('has-video');
        }
      },

      homeSlider: function() {
        // Prepare wrapper for Prev/Next arrows
        $('#slider').append('<div class="controls controls-arrows"><div class="inner"></div></div>');

        // Prepare wrapper for dots (pagination)
        if (jQuery('#slider .has-bullets').length) {
          $('#slider').append('<div class="controls controls-dots"><div class="inner"></div></div>');
        }

        // When slider is initialized
        $('#slider .slider').on('init', function(event, slick){
          // Add spans in slider pagination
          $(this).find('.slick-dots li button').wrapInner('<span />');
          $(this).parents('#slider').addClass('is-initialized');

          // Add 'hover' class when hovering the slider
          $(this).parents('#slider').hover(function(){
            $(this).addClass('hover');
          }, function(){
            $(this).removeClass('hover');
          });
        });

        // oPgsSliders.createNewSlick('home_slider', '#slider .slider');
        oPgsSliders.createNewSlick('home_slider', '#slider .slider');
      },

      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    'is_team' : {
      init: function() {
        // JavaScript to be fired on the team page

        UTIL.fire('is_team', 'pagerLoader');
        UTIL.fire('is_team', 'bindResetFilters');
      },

      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },

      // Animation/Transition with facet pagination
      pagerLoader: function() {
        var loaded = false;

        var target = '#mainContent .listing .team-list';


        $(document).on('facetwp-refresh', function() {
          if ( loaded ) {

            $(target).addClass('loading');

            $('<div class="listing-loading"></div>').insertAfter(target);
          }
        });

        $(document).on('facetwp-loaded', function() {

          // Hide container without any options available
          $.each(FWP.settings.num_choices, function(key, val) {
            var $parent = $('.facetwp-facet-' + key).parent();
            if( $parent.attr('data-keepclass') !== 'hidden' ){
              (0 === val) ? $parent.addClass('hidden') : $parent.removeClass('hidden');
            }
          });

          if ( loaded ) {

            $(target).removeClass('loading');

            if ($('#mainContent .listing .listing-loading').length ) {

              $('#mainContent .listing .listing-loading').fadeOut(100);

            }

            if( ! $('#mainContent #filter .facetwp-facet-team_section .facetwp-radio.checked').length ) {
              UTIL.fire('is_team', 'resetFilters');
            }
            else {
              $('#mainContent #filter [data-section="reset"]:first').removeClass('active');
            }

            if( target ) {
              $('html, body').animate({
                scrollTop: $(target).offset().top
              }, 500);
            }

          }
          else {
            loaded = true;
          }

        });
      },

      bindResetFilters: function() {
        $('#mainContent #filter [data-section="reset"]:first').on('click', function(){
          UTIL.fire('is_team', 'resetFilters');
        });
      },

      // Animation/Transition with facet pagination
      resetFilters: function() {
        var $jqButtonReset = $('#mainContent #filter [data-section="reset"]:first');
        if( $jqButtonReset.hasClass('active') ) {
          return;
        }

        if( $('#mainContent #filter .facetwp-facet-team_section .facetwp-radio.checked').length ) {
          FWP.reset('team_section');
        }

        $jqButtonReset.addClass('active');
      },

    },

    // Listing pages
    'is_listing': {
      init: function() {
        // JavaScript to be fired on the listing page

        if( $('body.is-new').length ) {
          // Facet infinite scroll
          UTIL.fire('is_listing', 'listingNewInfiniteScroll');
          UTIL.fire('is_listing', 'filterInStock');
        }

        if( $('body.is-used').length ) {
          UTIL.fire('is_listing', 'pagerLoader');
          UTIL.fire('is_listing', 'filterClearance');
          UTIL.fire('is_listing', 'usedStockSearch');
        }

        if( $('body.is-promos').length ) {
          UTIL.fire('is_listing', 'pagerLoader');
          UTIL.fire('is_listing', 'bindResetFilters');
        }

        if( $('body.is-blog').length ) {
          UTIL.fire('is_listing', 'pagerLoader');
        }

        if( $('body.is-careers').length ) {
          UTIL.fire('is_listing', 'pagerLoader');
        }

        if( $('body.is-product-boutique').length ) {
          UTIL.fire('is_listing', 'pagerLoader');
        }
      },

      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },

      usedStockSearch: function() {
        $('#stock-search').click(function() {
          $('.facetwp-autocomplete-update').click();
          return false;
        });
      },

      filterInStock: function() {
        $('#filter .status').hide();
        $(document).on('facetwp-loaded', function() {
          //////////////////////
          // In stock filter
          //////////////////////
          $('.facetwp-facet-new_instock .facetwp-checkbox').each(function(){

            // Hide native FacetWP checkboxes
            $(this).addClass('hidden');

            // Create checkbox input
            if ($(this).attr('data-value') === '1') {
              if(!$('#new_instock_checkbox').length){
                $('<input type="checkbox" id="new_instock_checkbox">').insertBefore($(this));
              }
            }
          });

          // Remove checkbox and print message if no results available
          if($('#new_instock_checkbox').length){
            $('.facetwp-facet-new_instock').parent().find('.status').hide();
          } else {
            $('.facetwp-facet-new_instock').parent().find('.status').show();
          }

          // Simulate click on FacetWP native checkbox
          $('#new_instock_checkbox').click(function(){
            $(this).next('.facetwp-checkbox').click();
          });

          // Check the checkbox if FacetWP native checkbox is checked
          if (window.location.href.indexOf("fwp_new_instock=1") > -1) {
            $('#new_instock_checkbox').prop('checked', true);
          } else {
            $('#new_instock_checkbox').prop('checked', false);
          }
        });
      },

      filterClearance: function() {
        $('#filter .status').hide();
        $(document).on('facetwp-loaded', function() {
          //////////////////////
          // Clearance filter
          //////////////////////
          $('.facetwp-facet-used_clearance .facetwp-checkbox').each(function(){

            // Hide native FacetWP checkboxes
            $(this).addClass('hidden');

            // Create checkbox input
            if ($(this).attr('data-value') === '1') {
              if(!$('#used_clearance_checkbox').length){
                $('<input type="checkbox" id="used_clearance_checkbox">').insertBefore($(this));
              }
            }
          });

          // Remove checkbox and print message if no results available
          if($('#used_clearance_checkbox').length){
            $('.facetwp-facet-used_clearance').parent().find('.status').hide();
          } else {
            $('.facetwp-facet-used_clearance').parent().find('.status').show();
          }

          // Simulate click on FacetWP native checkbox
          $('#used_clearance_checkbox').click(function(){
            $(this).next('.facetwp-checkbox').click();
          });

          // Check the checkbox if FacetWP native checkbox is checked
          if (window.location.href.indexOf("fwp_used_clearance=1") > -1) {
            $('#used_clearance_checkbox').prop('checked', true);
          } else {
            $('#used_clearance_checkbox').prop('checked', false);
          }
        });
      },

      bindResetFilters: function() {
        if( $('body.is-promos').length ) {
          $('#mainContent #filter [data-promotion="reset"]:first').on('click', function(){
            UTIL.fire('is_listing', 'resetFilters');
          });
        }
      },

      // Animation/Transition with facet pagination
      resetFilters: function() {
        var $jqButtonReset = $('#mainContent #filter [data-promotion="reset"]:first');
        if( $jqButtonReset.hasClass('active') ) {
          return;
        }

        if( $('#mainContent #filter .facetwp-facet-promotion_section_'+lang+' .facetwp-radio.checked').length ) {
          FWP.reset('promotion_section_'+lang);
        }

        $jqButtonReset.addClass('active');
      },

      // Animation/Transition with facet pagination
      pagerLoader: function() {
        var loaded = false;

        var target;
        var bIsPromo = false;
        var bIsBlog = false;
        var bIsCareers = false;

        if ($('body.is-new').length) {
          bIsNew = true;
          target = '#mainContent .listing .product-list';
        }
        else if ($('body.is-used').length) {
          target = '#mainContent .listing .product-list';
        }
        else if ($('body.is-promos').length) {
          bIsPromo = true;
          target = '#mainContent .listing .promotion-list';
        }
        else if ($('body.is-blog').length) {
          bIsBlog = true;
          target = '#mainContent .listing .blog-list';
        }
        else if ($('body.is-careers').length) {
          bIsCareers = true;
          target = '#mainContent .listing .career-list';
        }
        else if ($('body.is-product-boutique').length) {
          target = '#mainContent .listing .boutique-list';
        }

        $(document).on('facetwp-refresh', function() {
          if ( loaded ) {

            $(target).addClass('loading');

            $('<div class="listing-loading"></div>').insertAfter(target);
          }
        });

        $(document).on('facetwp-loaded', function() {

          // Hide container without any options available
          $.each(FWP.settings.num_choices, function(key, val) {
            var $parent = $('.facetwp-facet-' + key).parent();
            if( $parent.attr('data-keepclass') !== 'hidden' ){
              (0 === val) ? $parent.addClass('hidden') : $parent.removeClass('hidden');
            }
          });

          if ( loaded ) {

            $(target).removeClass('loading');

            if ($('#mainContent .listing .listing-loading').length ) {

              $('#mainContent .listing .listing-loading').fadeOut(100);

            }
            if( bIsPromo ) {
              if( ! $('#mainContent #filter .facetwp-facet-promotion_section_'+lang+' .facetwp-radio.checked').length ) {
                UTIL.fire('is_promos', 'resetFilters');
              }
              else {
                $('#mainContent #filter [data-promotion="reset"]:first').removeClass('active');
              }
            }

            if( target ) {
              $('html, body').animate({
                scrollTop: $(target).offset().top
              }, 500);
            }

          }
          else {
            loaded = true;
          }

        });
      },

      listingNewInfiniteScroll: function() {
        //if ($('.page-template-template-listing-new-vehicles').length) {
          window.fwp_is_paging = false;
          var pause = false;

          $(document).on('facetwp-refresh', function() {
            if (! window.fwp_is_paging) {
              window.fwp_page = 1;
              FWP.extras.per_page = 'default';
            }
            window.fwp_is_paging = false;
          });

          $(document).on('facetwp-loaded', function() {
            window.fwp_total_rows = FWP.settings.pager.total_rows;

            if (! FWP.loaded) {
              window.fwp_default_per_page = FWP.settings.pager.per_page;

              $(window).scroll(function() {
                if ( pause == false && $('#featRelated, #footerBefore').is( ':in-viewport' ) ) {
                  pause = true;

                  var rows_loaded = (window.fwp_page * window.fwp_default_per_page);
                  if (rows_loaded < window.fwp_total_rows) {
                    if($('.product-list + .listing-loading').length) {
                      $('.listing .listing-loading').fadeIn(100);
                    }
                    else {
                      $( "<div class='listing-loading'></div>" ).insertAfter('.product-list');
                    }

                    $('#mainContent .product-list .item .img a').removeAttr('style');
                    $('#mainContent .product-list .item .listWImgsContent').removeAttr('style');

                    window.fwp_page++;
                    window.fwp_is_paging = true;
                    FWP.extras.per_page = (window.fwp_page * window.fwp_default_per_page);
                    FWP.soft_refresh = true;
                    FWP.refresh();
                  }

                  setTimeout(function(){
                    pause = false;

                    if ($('.listing .listing-loading').length ) {
                      $('.listing .listing-loading').fadeOut(100);
                    }
                  }, 3000);
                }
              });
            }
          });
        //}
      },
    },

    // New details
    'is_details': {
      init: function() {
        // JavaScript to be fired on the new details page

        // Gallery
        UTIL.fire('is_details', 'detailsGallery');
      },

      detailsGallery: function(){
        oPgsSliders.createNewSlick('product_photos_big', '#product-photos .gallery .slider');
        oPgsSliders.createNewSlick('product_photos_nav', '#product-photos .gallery-nav .slider');

        // Unslick slider for Print version
        var beforePrint = function() {
          $('#product-photos').find('.gallery, .gallery-nav').find('.slider').slick('unslick');
        };
        var afterPrint = function() {
          oPgsSliders.createNewSlick('product_photos_big', '#product-photos .gallery .slider');
          oPgsSliders.createNewSlick('product_photos_nav', '#product-photos .gallery-nav .slider');
        };

        if (window.matchMedia) {
          var mediaQueryList = window.matchMedia('print');
          mediaQueryList.addListener(function(mql) {
            if (mql.matches) {
              beforePrint();
            } else {
              afterPrint();
            }
          });
        }

        window.onbeforeprint = beforePrint;
        window.onafterprint = afterPrint;
      },

      finalize: function() {
        // JavaScript to be fired after the init JS
      },
    },

    // Career listing
    'is_careers': {
      init: function() {
        // JavaScript to be fired on the new details page

        // Display About box
        UTIL.fire('is_careers', 'careerForm');
      },

      finalize: function() {
        // JavaScript to be fired after the init JS
      },

      careerForm: function() {
        $(document).on('facetwp-loaded', function() {
          $('.listing .career-list .item').each(function(){
            var label = $(this).find('h3').text();
            var value = $(this).find('h3').text();

            $('select#job').append($('<option>', {
              value: label,
              text: label
            }));
          });
        });
      },
    },

    'single_promotion': {
      init: function() {
        // JavaScript to be fired on the used details pages

        // initialize gallery
        UTIL.fire('single_promotion', 'imageGallery');

      },

      finalize: function() {
        // JavaScript to be fired after the init JS
      },

      // Set slickJS galleries for a single used vehicle
      imageGallery: function() {
        // Fancybox gallery
        $('#mainContent .photos a').on('click', function(event) {
          event.preventDefault();

          $("[data-fancybox]").fancybox({
            loop : true
          });
        });
      },
    },

    'is_giftcards': {
      init: function() {
        // JavaScript to be fired on the gift cards page

        // Update PayPal infos
        UTIL.fire('is_giftcards', 'giftcardSelect');

      },

      finalize: function() {
        // JavaScript to be fired after the init JS
      },

      // Update PayPal infos
      giftcardSelect: function() {
        var current_index;
        $('#giftcards').change(function(){
          current_index = $(this).find(":selected").attr('data-index');
          current_value = $(this).find(":selected").val();
          current_name = $('.giftcard-list .item[data-index="'+current_index+'"] h3').text();

          // Hide / show selected gift card
          $('.giftcard-list .item').hide();
          $('.giftcard-list .item[data-index="'+current_index+'"]').show();

          // Change PayPal form values
          $('#giftcard-paypal-item').val(current_name);
          $('#giftcard-paypal-value').val(current_value);
        }).change();

        $('#giftcard-paypal-qty-select').change(function(){
          current_qty = $(this).find(":selected").val();

          // Change PayPal form values
          $('#giftcard-paypal-quantity').val(current_qty);
        })
      },
    },

    // CODE TEMPLATE
    /*'body_class_code_template': {
      init: function() {
        // JavaScript to be fired on the used details pages

        // initialize Used vehicle slickJS galleries
        UTIL.fire('body_class_code_template', 'detailsGallery');

        // Columnizer installation procedure
        //   bower install jquery.columnizer --save
        //   Copy JS files from the master repository "/bower_components/jquery.columnizer/src/"

        // Columnizer on Options : on first page load
        UTIL.fire('body_class_code_template', 'columnizeOptions');

        // Columnizer : Window Resize
        UTIL.fire('body_class_code_template', 'onresizeColumnizeOptions');

      },

      finalize: function() {
        // JavaScript to be fired after the init JS
      },

      // Set slickJS galleries for a single used vehicle
      detailsGallery: function() {

        oPgsSliders.createNewSlick('realisation_photos_big', '#vehicle-photos .gallery .slider');
        oPgsSliders.createNewSlick('realisation_photos_nav', '#vehicle-photos .gallery-nav .slider');

      },


      columnizeOptions: function() {
        if(!$('#vehicle-options ul .column').length && (!$('body.mobile').length && !$('body.tablet').length)) {
          $('#vehicle-options ul').columnize({ columns: 3, buildOnce: true, lastNeverTallest: true });
          $('#vehicle-options ul').addClass('columnized');
        }

        if($('#vehicle-options ul .column').length && ($('body.mobile').length || $('body.tablet').length)) {
          $('#vehicle-options ul').uncolumnize();
          $('#vehicle-options ul').removeClass('columnized');
        }
      },

      onresizeColumnizeOptions: function() {
        $(window).on('resize', function(){
          UTIL.fire('body_class_code_template', 'columnizeOptions');
        });
      }

    },*/
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  // CF7 on_sent_ok
  formConfirmation = function(form_id) {
    var currentForm = $('form input[value='+form_id+']').closest('form');

    // Hide form
    $(currentForm).find('.fieldsets').slideUp(500);

    // Show confirmation message
    setTimeout(function() {
      $(currentForm).find('.conf-msg').fadeIn(500);
    }, 500);
  };

  // CF7 submit on_sent_ok or not
  formScroll = function(form_id) {
    // Scroll to header / conf msg
    var currentForm = $('form input[value='+form_id+']').closest('form');

    var $parentDiv = currentForm.parents('.fancybox-inner:first');
    if( $parentDiv.length ) {

      $parentDiv.scrollTop($parentDiv.scrollTop() + currentForm.position().top);

    }
    else {
      $('html, body').animate({
        scrollTop: $(currentForm).offset().top -20
      }, 500);
    }

  };

  // CF7 add class on validation error
  formInvalidFields = function(form_id) {
    var currentForm = $('form input[value='+form_id+']').closest('form');

    currentForm.find('.wpcf7-not-valid').closest('.form-group').addClass('has-error');
  };

  // Prevent multiple ajax calls from CF7 + W3TC
  // (Will need to be removed if site needs to have reCAPTCHA)
  $.fn.wpcf7OnloadRefill=function(){};

})(jQuery); // Fully reference jQuery after this point.
